import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BrandLogo from './BrandLogo';
import BrokenTrendIllustration from './BrokenTrendIllustration';
import ReferenceCode from './ReferenceCode';
import { VARIANTS, VARIANT_CONFIG } from './ErrorFallback.constants';
import {
  FallbackContainer,
  LogoSlot,
  FallbackTitle,
  FallbackMessage,
  Actions,
  PrimaryAction,
  GhostAction
} from './ErrorBoundary.styled';

// The one fallback every ErrorBoundary renders, in three sizes: `tile` inside a
// panel, `page` in place of a route's content, `app` for the whole viewport.
const ErrorFallback = ({ variant, retry, eventId }) => {
  const { t } = useTranslation();
  const config = VARIANT_CONFIG[variant];
  const say = ([key, defaultValue]) => t(key, { defaultValue });
  const resolve = action => (action === 'retry' ? retry : action);
  const { primary, secondary } = config;
  return (
    <FallbackContainer variant={variant} role="alert">
      {variant === 'app' && <LogoSlot><BrandLogo /></LogoSlot>}
      <BrokenTrendIllustration width={config.illustrationWidth} />
      <FallbackTitle variant={variant}>{say(config.title)}</FallbackTitle>
      {config.message && <FallbackMessage>{say(config.message)}</FallbackMessage>}
      <Actions>
        <PrimaryAction type="button" onClick={resolve(primary.action)}>{say(primary.label)}</PrimaryAction>
        {secondary && <GhostAction type="button" onClick={resolve(secondary.action)}>{say(secondary.label)}</GhostAction>}
      </Actions>
      {eventId && <ReferenceCode eventId={eventId} />}
    </FallbackContainer>
  );
};

ErrorFallback.propTypes = {
  variant: PropTypes.oneOf(VARIANTS),
  retry: PropTypes.func.isRequired,
  eventId: PropTypes.string
};

ErrorFallback.defaultProps = {
  variant: 'tile',
  eventId: null
};

export default ErrorFallback;
